<template>
  <div class="view-container">
    <vs-table :data="performanceData">

      <template slot="thead">
        <vs-th :key="i" class="text-base" v-for="(title, i) in header"
               :class="{'float-right': title === $t('projects.performanceTable.performance')}">{{ title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :class="tr.class" :data="tr" :key="indexTr" v-for="(tr, indexTr) in data">
          <vs-td :data="tr.name">
            {{ tr.name }}
          </vs-td>
          <vs-td :data="tr.total_worked">
            {{ tr.total_worked }} <span v-if="tr.to_approve">({{tr.to_approve}})</span>
          </vs-td>
          <vs-td :data="tr.approved_hours">
            {{ tr.approved_hours }}
          </vs-td>
          <vs-td class="text-right" :data="tr.performance">
            <span :class="getPerformanceClass(tr.performance)">{{tr.performance}}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

  </div>
</template>

<script>
  export default {
    name: "ProjectPerformanceComponent",
    props: {
      performanceData: {
        required: true,
        type: Array,
      },
      header: {
        required: true,
        type: Array,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getPerformanceClass (performance) {
        performance = parseFloat(performance.replace('%', ''));
        if (performance === 100) {
          return 'bg-green-500 text-white px-2 py-1';
        }
        if (performance > 100) {
          return 'bg-green-900 text-white px-2 py-1';
        }
        if (performance < 100 && performance > 95) {
          return 'bg-green-400 text-white px-2 py-1';
        }
        if (performance <= 95 && performance >= 90) {
          return 'bg-green-300 text-white px-2 py-1';
        }
        return 'bg-red-500 text-white px-2 py-1';
      },
    },
  }
</script>

<style lang="scss">
  .positive {
    @apply text-green-500;
    &:before {
      content: '+'
    }
  }

  .negative {
    @apply text-red-500;
    &:before {
      content: '-'
    }
  }

</style>
